import { render, staticRenderFns } from "./BlogDate.vue?vue&type=template&id=267e4dd1&scoped=true"
import script from "./BlogDate.vue?vue&type=script&lang=js"
export * from "./BlogDate.vue?vue&type=script&lang=js"
import style0 from "./BlogDate.vue?vue&type=style&index=0&id=267e4dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e4dd1",
  null
  
)

export default component.exports